/**
 *  map.serv.js
 */

class mapServ {

    constructor($rootScope, $sce, $http, apiServ, shopTypesServ, assetsServ,$location) {

        this.$location = $location;
        this.$rootScope = $rootScope;
        this.$sce = $sce;
        this.$http = $http;
        this.apiServ = apiServ;
        this.shopTypesServ = shopTypesServ;
        this.assetsServ = assetsServ;
        this.cachedShops = undefined;
        this.mapOptions = {
            lat: 45.9432,
            lng: 24.9668,
            zoom: 6
        };

        this.zoomWhenTheMapIsPointedToCoordinates = 15;

        this.countryBounds = {
            southWest: {
                lat: 47.925176,
                lng: 20.706121
            },
            northEast: {
                lat: 43.740939,
                lng: 28.561345
            }
        };

        this.markerOptions = {
            icon: {
                user: this.assetsServ.getAssetByTypeAndDevicePixelRatio('user-location'),
                shop: this.assetsServ.getAssetByTypeAndDevicePixelRatio(this.shopTypesServ.getTypeShop()),
                store: this.assetsServ.getAssetByTypeAndDevicePixelRatio(this.shopTypesServ.getTypeStore()),
                smartStore: this.assetsServ.getAssetByTypeAndDevicePixelRatio(this.shopTypesServ.getTypeSmartStore()),
                strategic:  this.assetsServ.getAssetByTypeAndDevicePixelRatio(this.shopTypesServ.getTypeStrategic()),
                dealer:  this.assetsServ.getAssetByTypeAndDevicePixelRatio(this.shopTypesServ.getTypeDealer()),
                tkrShop:  this.assetsServ.getAssetByTypeAndDevicePixelRatio(this.shopTypesServ.getTypeTkr()),
                omMerchant: this.assetsServ.getAssetByTypeAndDevicePixelRatio(this.shopTypesServ.getTypeOmMerchant()),
                [this.shopTypesServ.getSubTypeFashion()]: this.assetsServ.getAssetByTypeAndDevicePixelRatio(this.shopTypesServ.getSubTypeFashion(), '3x'),
                [this.shopTypesServ.getSubTypeSupermarket()]: this.assetsServ.getAssetByTypeAndDevicePixelRatio(this.shopTypesServ.getSubTypeSupermarket(), '3x'),
                [this.shopTypesServ.getSubTypeRestaurants()]: this.assetsServ.getAssetByTypeAndDevicePixelRatio(this.shopTypesServ.getSubTypeRestaurants(), '3x'),
                [this.shopTypesServ.getSubTypeFreeTime()]: this.assetsServ.getAssetByTypeAndDevicePixelRatio(this.shopTypesServ.getSubTypeFreeTime(), '3x'),
                [this.shopTypesServ.getSubTypeHealth()]: this.assetsServ.getAssetByTypeAndDevicePixelRatio(this.shopTypesServ.getSubTypeHealth(), '3x'),
                [this.shopTypesServ.getSubTypeServices()]: this.assetsServ.getAssetByTypeAndDevicePixelRatio(this.shopTypesServ.getSubTypeServices(), '3x'),
                [this.shopTypesServ.getSubTypeElectronics()]: this.assetsServ.getAssetByTypeAndDevicePixelRatio(this.shopTypesServ.getSubTypeElectronics(), '3x'),
                [this.shopTypesServ.getSubTypeMarket()]: this.assetsServ.getAssetByTypeAndDevicePixelRatio(this.shopTypesServ.getSubTypeMarket(), '3x')
            },
            zIndex: {
                user: 15,
                shop: 5,
                store: 5,
                smartStore: 10,
                strategic: 5,
                dealer: 5,
                tkrShop: 5,
                omMerchant: 5
            },
            smallSize: 48,
            bigSize: 60
        };

        this.markerClustererBaseStyle = {
            'anchorText': [-13, 0],
            'textColor': '#000',
            'url': this.assetsServ.getAssetByTypeAndDevicePixelRatio('clusterer'),
            'height': 53,
            'width': 79
        };

        this.markerClustererOptions = {
            maxZoom: 12,
            styles: [this.markerClustererBaseStyle, this.markerClustererBaseStyle, this.markerClustererBaseStyle]
        };
    }

    _transformCoordinatesStringIntoObject(shop) {
        let splitCoordinates = shop.placemarkPoint.coordinates.split(',');
        return Object.assign({}, shop, {
            placemarkPoint: Object.assign({}, shop.placemarkPoint, {
                coordinates: {
                    lat: splitCoordinates[1],
                    lng: splitCoordinates[0]
                }
            })
        });
    }

    readMapOptions() {
        return this.mapOptions;
    }

    readMarkerClustererOptions() {
        return this.markerClustererOptions;
    }

    readMarkerOptions() {
        return this.markerOptions;
    }

    readShops(shopType, canceller) {
        if (this.cachedShops) {
            return Promise.resolve(this.filterShops(this.cachedShops, shopType));
        } else {
            return this.$http({
                url: this.getShopUrlByContext(shopType.context),
                method: 'GET',
                timeout: canceller.promise
            }).then((successResp) => {
                this.cachedShops = successResp.data.placemarks.placemarks;
                return Promise.resolve(this.filterShops(this.cachedShops, shopType));
            }, () => {
                return Promise.reject([]);
            });
        }
    }

    filterShops(shops, shopType) {
        return shops
            .filter((shop) => shopType.typeFilters.length > 0 ?
                shopType.typeFilters.indexOf(shop.type) > -1 :
                true)
            .filter((shopFilteredByType) => shopType.subTypeFilters.length > 0 ?
                shopType.subTypeFilters.indexOf(shopFilteredByType.subType) > -1 :
                true);
    }

    getShopUrlByContext(context) {
        return context === this.shopTypesServ.context.shops ?
            this.apiServ.readUrl(this.shopTypesServ.context.shops) :
            this.apiServ.readUrl(this.shopTypesServ.context.orangemoney);
    }

    readCountryBounds() {
        return this.countryBounds;
    }

    createNewInfoWindowScope() {
        let $infoWindowScope = this.$rootScope.$new();
        return $infoWindowScope;
    }

    getZoomWhenTheMapIsPointedToCoordinates() {
        return this.zoomWhenTheMapIsPointedToCoordinates;
    }

    destroyScope(scope) {
        scope.$destroy();
    }
}

mapServ.$inject = ['$rootScope', '$sce', '$http', 'apiServ', 'shopTypesServ', 'assetsServ','$location'];

export default mapServ;
